import { useEffect } from "react";

const TawkTo = () => {
    useEffect(() => {
        window.Tawk_API = window.Tawk_API || {};
        Window.Tawk_LoadStart = new Date();
        (function () {
            var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
            s1.async = true;
            s1.src = 'https://embed.tawk.to/6955356b7665ef197dae1b8c/1jdqdhbpu';
            s1.charset = 'UTF-8';
            s1.setAttribute('crossorigin', '*');
            s0.parentNode.insertBefore(s1, s0);
        })();
    }, []);

    return null;
};

export default TawkTo;